import React, {Component} from 'react';
import './dashboard.scss'
export default class dashboard extends Component {

  render() {
      return (
          <div className="page-dashboard">
              Hello dashboard
          </div>
      )
  }
}
